/**
 * Document Categories Configuration
 * Defines document types, categories, colors, and icons
 */

export const DOCUMENT_CATEGORIES = {
  pay_earnings: {
    label: 'Payslips',
    icon: 'Banknote',
    color: 'amber',
    bgColor: 'bg-amber-500/10',
    textColor: 'text-amber-400',
    borderColor: 'border-amber-500/30',
    types: ['wage_slip']
  },
  tax_documents: {
    label: 'P45/P60/P11D',
    icon: 'FileText',
    color: 'purple',
    bgColor: 'bg-purple-500/10',
    textColor: 'text-purple-400',
    borderColor: 'border-purple-500/30',
    types: ['p45', 'p60', 'p11d']
  },
  travel: {
    label: 'Travel',
    icon: 'Plane',
    color: 'blue',
    bgColor: 'bg-blue-500/10',
    textColor: 'text-blue-400',
    borderColor: 'border-blue-500/30',
    types: ['flight_stub', 'boarding_pass', 'travel_receipt', 'vessel_positions']
  },
  receipts: {
    label: 'Receipts & Expenses',
    icon: 'Receipt',
    color: 'amber',
    bgColor: 'bg-amber-500/10',
    textColor: 'text-amber-400',
    borderColor: 'border-amber-500/30',
    types: ['receipt', 'expense_claim', 'invoice']
  },
  other: {
    label: 'Other Documents',
    icon: 'Folder',
    color: 'slate',
    bgColor: 'bg-slate-500/10',
    textColor: 'text-slate-400',
    borderColor: 'border-slate-500/30',
    types: ['seamans_discharge_book', 'other']
  }
};

// Map document types to their display labels
export const DOCUMENT_TYPE_LABELS = {
  wage_slip: 'Wage Slip',
  p45: 'P45',
  p60: 'P60',
  p11d: 'P11D',
  flight_stub: 'Flight Stub',
  boarding_pass: 'Boarding Pass',
  travel_receipt: 'Travel Receipt',
  vessel_positions: 'Vessel Midnight Positions',
  receipt: 'Receipt',
  expense_claim: 'Expense Claim',
  invoice: 'Invoice',
  seamans_discharge_book: "Seaman's Discharge Book",
  other: 'Other'
};

/**
 * Get category for a document type
 */
export const getCategoryForType = (documentType) => {
  for (const [categoryKey, category] of Object.entries(DOCUMENT_CATEGORIES)) {
    if (category.types.includes(documentType)) {
      return { key: categoryKey, ...category };
    }
  }
  return { key: 'other', ...DOCUMENT_CATEGORIES.other };
};

/**
 * Get display label for document type
 */
export const getDocumentTypeLabel = (type) => {
  return DOCUMENT_TYPE_LABELS[type] || type;
};

/**
 * Group documents by category
 */
export const groupDocumentsByCategory = (documents) => {
  const grouped = {};
  
  // Initialize all categories
  Object.keys(DOCUMENT_CATEGORIES).forEach(key => {
    grouped[key] = {
      ...DOCUMENT_CATEGORIES[key],
      key,
      documents: []
    };
  });
  
  // Group documents
  documents.forEach(doc => {
    const category = getCategoryForType(doc.document_type);
    grouped[category.key].documents.push(doc);
  });
  
  // Return only categories with documents, maintaining order
  return Object.entries(grouped)
    .filter(([_, cat]) => cat.documents.length > 0)
    .map(([key, cat]) => ({ ...cat, key }));
};
